import React, { useEffect } from "react";
import Login from "./pages/Login";
import { ToastContainer } from "react-toastify";
import FingerPrintComponent from "./components/FingerprintComponent";
import FingerprintScannerLoader from "./components/FingerprintScannerLoader";
import ApiLoader from "./components/ApiLoader";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useNavigationType,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import ImportPde from "./pages/ImportPde";
import CopyReceipt from "./pages/CopyReceipt";
import DeficiateReceipt from "./pages/DeficiateReceipt";
import InspectionReceipt from "./pages/InspectionReceipt";
import OtherReceipt from "./pages/OtherReceipt";
import Commision from "./pages/Commision";
import SearchReceipt from "./pages/SearchReceipt";
import ModifyFeeValuationBeforeReg from "./pages/ModifyFeeValuationBeforeReg";
import ModifyReciept from "./pages/ModifyReceipt";
import NewRecieptDeficiate from "./pages/ModifyReceipt";
import RegistrationTokenList from "./pages/RegistrationTokenList";
import PhotoThumbSignForm from "./pages/PhotoThumbSignForm";
import ModifyPartyDetailsBeforeReg from "./pages/ModifyPartyDetailsBeforeReg";
import ModifyRegReciept from "./pages/ModifyRegReciept";
import ErrorPage from "./pages/ErrorPage";
import ModifyDeedName from "./pages/ModifyDeedName";
import ModifyPDEdetailsAfterSubmit from "./pages/ModifyPDEdetailsAfterSubmit";
import Test from "./pages/Test";
import EndorsementReport from "./pages/EndorsementReport";
import PostponedRegistrationTokenList from "./pages/PostponedRegistrationTokenList";
import Scan from "./pages/Scan";
import PrintDoc from "./pages/PrintDoc";
import PowerRegularization from "./pages/PowerRegularization";
import NewReceipt from "./pages/NewReceipt";
import WebexFormTest from "./pages/WebexFormTest";
import Challan from "./pages/Challan";
import ShyahReport from "./pages/ShyahReport";
import PowerRegularizationAIGAction from "./pages/PowerRegularizationAIGAction";
import RegularizationApproval from "./pages/RegularizationApproval";
import Statement2 from "./pages/Statement2";
import MonthlyReports from "./pages/MonthlyReports";
import ModifyModal from "./Modal/ModifyModal";

import Esign from "./pages/Esign";
import Other from "./pages/Other";
import EndorsementFinal from "./pages/EndorsementFinal";
import UserCreation from "./pages/UserCreation";
import DashboardAIG from "./pages/DashboardAIG";
import PrintReceiptReport from "./pages/PrintReceiptReport";
import BankFileModal from "./Modal/BankFileModal";
import BankFileLand from "./pages/BankFileLand";
import DummyModal from "./Modal/DummyModal";
import { useDispatch, useSelector } from "react-redux";
import HighestSaleDeeds from "./pages/HighestSaleDeeds";
import IndexForm from "./pages/IndexForm";
import VapsiRegister from "./pages/VapsiRegister";
import TehsilVapsiRegister from "./pages/TehsilVapsiRegister";
import TransactionReports from "./pages/TransactionReports";
import VirtualRegistrationTokenList from "./pages/VirtualRegistrationTokenList";
import PdeReview from "./pages/PdeReview";
import PowerRegularizationItCell from "./pages/PowerRegularizationItCell";
import PdeDetails from "./pages/PdeDetails";
import ListOfScanDocumentsDatewise from "./pages/ListOfScanDocumentsDatewise";
import DashboardRegDetails from "./pages/DashboardRegDetails";
import { logOut } from "./redux-store/slices/authSlice";
import ComparisonData from "./pages/ComparisonData";
import ACIRDeeds from "./pages/ACIRDeeds";
import IncomeSummary from "./pages/IncomeSummary";
import TopDeeds from "./pages/TopDeeds";
import ValueRangeDeeds from "./pages/ValueRangeDeeds";
import ChallanDetails from "./pages/ChallanDetails";
import ExamplerDetails from "./pages/ExamplerDetails";
import TehsilRegistry from "./pages/TehsilRegistry";
import AgriNonAgriExampler from "./pages/AgriNonAgriExampler";
import SROWiseLocationExamplerAndTotalDoc from "./pages/SROWiseLocationExamplerAndTotalDoc";
import SpotInspection from "./pages/SpotInspection";
import DistrictDeedWiseReport from "./pages/DistrictDeedWiseReport";
import DscRegularization from "./pages/DscRegularization";
import PrithuReport from "./pages/PrithuReport";
import ScanningReport from "./pages/ScanningReport";
import ParganaWiseReport from "./pages/ParganaWiseReport";
import TotalDocRevReport from "./pages/TotalDocRevReport";
import DistrictLocationExamplerReport from "./pages/DistrictLocationExamplerReport";
import SroTimeManager from "./pages/SroTimeManager";

// Handles "back"/"forward" into /Login by clearing session
function SessionExpiryHandler() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navType = useNavigationType(); // "POP" on back/forward
  const navigate = useNavigate();

  useEffect(() => {
    // only when the user hits Back (POP) _and_ ends up at “/”
    if (navType === "POP" && location.pathname === "/") {
      // 1) clear all storage
      sessionStorage.clear();
      localStorage.clear();

      // 2) update your Redux so isLoggedIn → false
      dispatch(logOut());

      // 3) redirect to “/” with replace, blowing away that history entry
      navigate("/", { replace: true });
    }
  }, [navType, location.pathname, dispatch, navigate]);
  return null;
}

const App = () => {
  const { userDetails } = useSelector((state) => state.auth);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  // useEffect(() => {
  //   // Disable Right-Click
  //   document.addEventListener("contextmenu", (event) => event.preventDefault());

  //   // Disable Developer Tools Shortcuts
  //   const disableShortcuts = (event) => {
  //     if (
  //       event.key === "F12" ||
  //       (event.ctrlKey &&
  //         event.shiftKey &&
  //         (event.key === "I" || event.key === "J")) ||
  //       (event.ctrlKey && event.key === "U")
  //     ) {
  //       event.preventDefault();
  //     }
  //   };
  //   document.addEventListener("keydown", disableShortcuts);

  //   // Detect DevTools
  //   const checkDevTools = setInterval(() => {
  //     const devtools =
  //       window.outerWidth - window.innerWidth > 200 ||
  //       window.outerHeight - window.innerHeight > 200;
  //     if (devtools) {
  //       alert("Developer Tools Detected! Closing...");
  //       window.location.reload();
  //     }
  //   }, 1000);

  //   // Cleanup listeners on unmount
  //   return () => {
  //     document.removeEventListener("contextmenu", (event) =>
  //       event.preventDefault()
  //     );
  //     document.removeEventListener("keydown", disableShortcuts);
  //     clearInterval(checkDevTools);
  //   };
  // }, []);

  return (
    <>
      <SessionExpiryHandler />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes */}
        {isLoggedIn && (
          <>
            <Route path="/Test" element={<Test />} />
            <Route path="/Modify" element={<ModifyModal />} />
            <Route path="/BankFileModal" element={<BankFileModal />} />
            <Route path="/MonthlyReports" element={<MonthlyReports />} />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/ImportPde" element={<ImportPde />} />
            <Route path="/ShyahReport" element={<ShyahReport />} />
            <Route path="/EndorsementFinal" element={<EndorsementFinal />} />
            <Route
              path="/PhotoThumbSignForm"
              element={<PhotoThumbSignForm />}
            />
            <Route path="/BankFileLand" element={<BankFileLand />} />
            <Route path="/DummyModal" element={<DummyModal />} />
            <Route
              path="/ModifyPartyDetailsBeforeReg"
              element={<ModifyPartyDetailsBeforeReg />}
            />
            <Route
              path="/ModifyFeeValuationBeforeReg"
              element={<ModifyFeeValuationBeforeReg />}
            />
            <Route
              path="/RegistrationTokenList"
              element={<RegistrationTokenList />}
            />
            <Route
              path="/VirtualRegistrationTokenList"
              element={<VirtualRegistrationTokenList />}
            />
            <Route path="/ModifyRegReciept" element={<ModifyRegReciept />} />
            <Route path="/ErrorPage" element={<ErrorPage />} />
            <Route path="/ModifyDeedName" element={<ModifyDeedName />} />
            <Route path="/IndexForm" element={<IndexForm />} />
            <Route path="/VapsiRegister" element={<VapsiRegister />} />
            <Route
              path="/TransactionReports"
              element={<TransactionReports />}
            />
            <Route
              path="/TehsilVapsiRegister"
              element={<TehsilVapsiRegister />}
            />
            <Route
              path="/ModifyPDEdetailsAfterSubmit"
              element={<ModifyPDEdetailsAfterSubmit />}
            />
            <Route path="/EndorsementReport" element={<EndorsementReport />} />
            <Route path="/HighestSaleDeeds" element={<HighestSaleDeeds />} />
            <Route
              path="/PostponedRegistrationTokenList"
              element={<PostponedRegistrationTokenList />}
            />
            <Route path="/Scan" element={<Scan />} />
            <Route path="/PrintDoc" element={<PrintDoc />} />
            <Route
              path="/ListOfScanDocumentsDatewise"
              element={<ListOfScanDocumentsDatewise />}
            />

            <Route path="/WebexForm" element={<WebexFormTest />} />
            <Route path="/NewReceipt" element={<NewReceipt />} />
            <Route path="/ModifyReciept" element={<ModifyReciept />} />
            <Route
              path="/NewRecieptDeficiate"
              element={<NewRecieptDeficiate />}
            />
            <Route path="/Commision" element={<Commision />} />
            <Route path="/CopyReceipt" element={<CopyReceipt />} />
            <Route path="/DeficiateReceipt" element={<DeficiateReceipt />} />
            <Route path="/InspectionReceipt" element={<InspectionReceipt />} />
            <Route path="/OtherReceipt" element={<OtherReceipt />} />
            <Route path="/SearchReceipt" element={<SearchReceipt />} />
            <Route path="/Challan" element={<Challan />} />
            <Route path="/eSign" element={<Esign />} />
            <Route path="/Other" element={<Other />} />
            <Route path="/Statement2" element={<Statement2 />} />
            <Route
              path="/PrintReceiptReport"
              element={<PrintReceiptReport />}
            />
            <Route
              path="/PowerRegularization"
              element={<PowerRegularization />}
            />
            <Route path="/PdeReview" element={<PdeReview />} />
            <Route path="/DscRegularization" element={<DscRegularization />} />
            {/* <Route path="/PdeDetails" element={<PdeDetails />} /> */}
            <Route path="/pde-review/:pdeId" element={<PdeDetails />} />

            {/* Conditional Routes Based on Role */}
            {userDetails?.userRole === "SuperAdmin" && (
              <>
                <Route path="/DashboardAIG" element={<DashboardAIG />} />
                <Route path="/UserCreation" element={<UserCreation />} />
                <Route path="/ComparisonData" element={<ComparisonData />} />
                <Route path="/IncomeSummary" element={<IncomeSummary />} />
                <Route path="/TopDeeds" element={<TopDeeds />} />
                <Route path="/ACIRDeeds" element={<ACIRDeeds />} />
                <Route path="/ValueRangeDeeds" element={<ValueRangeDeeds />} />
                <Route path="/ChallanDetails" element={<ChallanDetails />} />
                <Route path="/ExamplerDetails" element={<ExamplerDetails />} />
                <Route path="/TehsilRegistry" element={<TehsilRegistry />} />
                <Route
                  path="/AgriNonAgriExampler"
                  element={<AgriNonAgriExampler />}
                />
                <Route
                  path="/SROWiseLocationExamplerAndTotalDoc"
                  element={<SROWiseLocationExamplerAndTotalDoc />}
                />
                <Route path="/SpotInspection" element={<SpotInspection />} />
                <Route
                  path="/DistrictDeedWiseReport"
                  element={<DistrictDeedWiseReport />}
                />
                <Route path="/PrithuReport" element={<PrithuReport />} />
                <Route path="/ScanningReport" element={<ScanningReport />} />
                <Route
                  path="/ParganaWiseReport"
                  element={<ParganaWiseReport />}
                />
                <Route
                  path="/TotalDocRevReport"
                  element={<TotalDocRevReport />}
                />
                <Route
                  path="/DistrictLocationExamplerReport"
                  element={<DistrictLocationExamplerReport />}
                />
                <Route
                  path="/RegularizationApproval"
                  element={<RegularizationApproval />}
                />
                <Route
                  path="/PowerRegularizationAIGAction"
                  element={<PowerRegularizationAIGAction />}
                />
              </>
            )}

            {userDetails?.userRole === "ItCell" && (
              <>
                <Route
                  path="/PowerRegularizationItCell"
                  element={<PowerRegularizationItCell />}
                />
                <Route path="/SroTimeManager" element={<SroTimeManager />} />
              </>
            )}
            {userDetails?.userRole === "NIC Director" && (
              <>
                <Route
                  path="/DashboardRegDetails"
                  element={<DashboardRegDetails />}
                />
              </>
            )}
          </>
        )}

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

export default App;
